import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { RolesComponent } from './tabs/roles/roles.component';
import { AssignmentComponent } from './tabs/assignment/assignment.component';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIcon,
    MatCard,
    MatProgressSpinnerModule,
    MatTabsModule,
    RolesComponent,
    AssignmentComponent
  ]
})
export class PermissionsComponent {

  @ViewChild(RolesComponent) rolesComponent!: RolesComponent;
  @ViewChild(AssignmentComponent) assignmentComponent!: AssignmentComponent;

  tabIndex = 0;

  tabChanged(tabChangeEvent: MatTabChangeEvent) {
    this.tabIndex = tabChangeEvent.index;
  }

  isSaving(): boolean {
    if (this.tabIndex === 1) {
      return this.assignmentComponent?.saving.value ?? false;
    }

    return false;
  }

  async onSaveClick(): Promise<void> {
    if (this.tabIndex === 1) {
      await this.assignmentComponent.onSaveClick();
    }
  }

  onCreateRoleClick(): void {
    this.rolesComponent?.onCreateClick();
  }

  onRolesChanged(): void {
    this.assignmentComponent?.loadPage();
  }
}
